import orgModuleGetters from "./orgModule/getters";
import vendorModuleGetters from "./vendorModule/getters";

const getPreacriberLookup = state => {
  return state.prescribers;
};

export default {
  ...orgModuleGetters,
  ...vendorModuleGetters,
  getPreacriberLookup,
};
